import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Merge } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const ContentMergerNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Content Appender'}
        icon={Merge}
        colorClass="from-teal-500 to-teal-700"
        bgClass="bg-gradient-to-br from-teal-500 to-teal-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
ContentMergerNode.displayName = 'ContentMergerNode';
export default ContentMergerNode;
